import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  actions as uiActions,
} from '@/reducers/ui';
import {
  actions as clientActions,
} from '@/reducers/client';
import { getModuleNamesTagginInfo } from '@/utils/index';
import PreventionModal from './PreventionModal';
import RetenModal from './RetenModal';
import C2CModal from './C2CModal';
import C2CRetentionModalV2 from './C2CRetentionModalV2';
import { PUSSUB_STATES_DICTIONARY } from '@/utils/constants';

const C2C_RETENTION_CAMPAIGN_ID = 'retencion-900';

const PREVENTION_TYPES = {
  PREVENTION: 'prevention',
  RETENTION: 'retention',
  C2C: 'c2c',
};

const PreventionsModal = ({
  screenType,
  preventions,
  purchaseProcess,
}) => {
  const dispatch = useDispatch();
  const [currentPrevention, setCurrentPrevention] = useState(0);

  const layout = useSelector((state) => state.UI.layout);
  const clientModules = useSelector((state) => state.client.modulos);
  const misDatos = useSelector((state) => state.client.misDatos);
  const modulos = useSelector((state) => state.cart.modulos);

  const componentProduct = getModuleNamesTagginInfo(modulos, layout, clientModules);
  const prevention = preventions[currentPrevention];
  const showC2CRetentionModalV2 = (
    prevention?.type === PREVENTION_TYPES.C2C
    && prevention?.idCampaign === C2C_RETENTION_CAMPAIGN_ID
    
  );

  const onClickHandler = (c2c) => {
    // ir a la siguiente prevention
    if (preventions[currentPrevention + 1]
        && !(preventions[currentPrevention + 1].type === PREVENTION_TYPES.RETENTION
        && Array.isArray(preventions[currentPrevention + 1]?.promotions)
        && preventions[currentPrevention + 1]?.promotions.length === 0)) {
          setCurrentPrevention(currentPrevention + 1);
          if (!misDatos && preventions[currentPrevention + 1].type === PREVENTION_TYPES.C2C) {
            dispatch(clientActions.getMyData());
          }
        
      
    } else {
      // mandar mensaje de que va al proceso de compra 
      // si no hay mas preventions-> ir al proceso de compra

      dispatch(uiActions.navigate2PurchaseProcess({ purchaseProcess: c2c || purchaseProcess }));
    }
  }

  if (
    preventions[currentPrevention].type !== PREVENTION_TYPES.PREVENTION
    && preventions[currentPrevention].type !== PREVENTION_TYPES.RETENTION
    && preventions[currentPrevention].type !== PREVENTION_TYPES.C2C
  ) {
    // type no contemplado -> siguiente prevention
    onClickHandler();
    return null;
  }

  return (
    <>
      {preventions[currentPrevention].type === PREVENTION_TYPES.PREVENTION && (
        <PreventionModal
          data={preventions[currentPrevention]}
          screenType={screenType}
          onClick={onClickHandler}
          componentProduct={componentProduct}
        />
      )}
      {prevention.type === PREVENTION_TYPES.RETENTION && (
        <RetenModal
          data={prevention}
          onClick={onClickHandler}
          componentProduct={componentProduct}
        />
      )}
      {showC2CRetentionModalV2 && (
        <C2CRetentionModalV2 
        data={preventions[currentPrevention - 1]}
        componentProduct={componentProduct}
        />
      )}
      {prevention.type === PREVENTION_TYPES.C2C && !showC2CRetentionModalV2 && (
        <C2CModal
          data={prevention}
          screenType={screenType}
          onClick={onClickHandler}
          componentProduct={componentProduct}
        />
      )}
    </>
  )
}

export default PreventionsModal;
